document.addEventListener("click", function (e) {
  if (e.target.id === "apply-discount-btn") {

    const input = document.querySelector('input[name="discount"]');
    if (!input || input.value.trim() === "") return;

    const code = input.value.trim();

    // REAL SHOPIFY DISCOUNT APPLY
    window.location.href = `/discount/${code}?redirect=/cart`;
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);

  if (document.cookie.includes("discount_code")) {
    confetti({
      particleCount: 140,
      spread: 80,
      origin: { y: 0.65 }
    });

    showCouponMessage();
  }
});

function showCouponMessage() {
  const msg = document.createElement("div");
  msg.innerHTML = "🎉 Coupon Applied Successfully!";
  msg.style.position = "fixed";
  msg.style.top = "18%";
  msg.style.left = "50%";
  msg.style.transform = "translateX(-50%)";
  msg.style.background = "#1b5e20";
  msg.style.color = "#ffffff";
  msg.style.padding = "14px 26px";
  msg.style.borderRadius = "30px";
  msg.style.zIndex = "9999";
  msg.style.fontSize = "16px";
  msg.style.boxShadow = "0 6px 20px rgba(0,0,0,0.25)";

  document.body.appendChild(msg);
  setTimeout(() => msg.remove(), 2600);
}
